import { deferred } from './deferred';

/** Returns a promise which resolves (with no value) after the given time has elapsed */
export const sleep = (periodMs: number) => {
  const { promise, resolve } = deferred<void>();
  setTimeout(() => resolve(), periodMs);
  return promise;
};
